import { render } from "./TaskStatusSelect.vue?vue&type=template&id=baa815c2&scoped=true&ts=true"
import script from "./TaskStatusSelect.vue?vue&type=script&lang=ts"
export * from "./TaskStatusSelect.vue?vue&type=script&lang=ts"

import "./TaskStatusSelect.vue?vue&type=style&index=0&id=baa815c2&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-baa815c2"]])

export default __exports__